import React from 'react';
import { cn } from '../../../lib/utils';

export interface TaskyCheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
  wrapperClassName?: string;
}

export const TaskyCheckbox = React.forwardRef<HTMLInputElement, TaskyCheckboxProps>(
  ({ className, wrapperClassName, label, disabled, ...rest }, ref) => (
    <label
      className={cn(
        'inline-flex items-center gap-2 select-none cursor-pointer',
        disabled && 'opacity-60 cursor-not-allowed',
        wrapperClassName,
      )}
    >
      <input
        ref={ref}
        type="checkbox"
        disabled={disabled}
        {...rest}
        className={cn(
          'h-4 w-4 rounded border-warm-border text-primary',
          'focus:ring-2 focus:ring-primary/40 focus:ring-offset-0',
          'transition-colors cursor-pointer disabled:cursor-not-allowed',
          className,
        )}
      />
      {label && <span className="text-sm text-dark">{label}</span>}
    </label>
  ),
);
TaskyCheckbox.displayName = 'TaskyCheckbox';
